import moment from 'moment-timezone';

export const diffDates = (
  date: string | moment.Moment,
  unitOfTime: 'days' | 'months' = 'days',
): number =>
  Math.round(
    (moment.isMoment(date) ? date : moment(date).endOf(unitOfTime)).diff(
      moment(),
      unitOfTime,
      unitOfTime === 'months',
    ),
  );
